module.exports = __webpack_public_path__ + "static/dragonborn-scag-fadfb23ba8e5b31065f7b191037091bc.png";